// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"f27076d8","257":"9698e818","635":"01057f7c","660":"58054f18","848":"cc3a9f62","865":"3e65b8ec"}[chunkId] + ".chunk.js";
};